import {
    AuthAction,
    withUser
} from 'next-firebase-auth';
import Link from 'next/link';
import FirebaseAuth from '../components/firebase-auth';

const styles = {
    content: {
        padding: `8px 32px`,
    },
    textContainer: {
        display: 'flex',
        justifyContent: 'center',
        margin: 16,
    },
}

const Auth = () => {
    return (
        <div className="body-bg min-h-screen pt-12 md:pt-20 pb-6 px-2 md:px-0" style={{
            fontFamily: "'Lato',sans-serif",
            backgroundColor: "#9921e8",
            backgroundImage: "linear-gradient(315deg, #9921e8 0%, #5f72be 74%)",
        }}>
            <header className="max-w-lg mx-auto">
                <a href="#">
                    <h1 className="text-4xl font-bold text-white text-center">Aquinas</h1>
                </a>
            </header>

            <div className="my-5 md:my-32">
                <FirebaseAuth />
            </div>

            <footer className="max-w-lg mx-auto flex justify-center text-white">
                <a href="#" className="hover:underline">Contact</a>
                <span className="mx-3">•</span>
                <Link href="/privacy" className="hover:underline">Privacy</Link>
            </footer>
        </div>
    );
}

export default withUser({
    whenAuthed: AuthAction.REDIRECT_TO_APP,
    whenUnauthedBeforeInit: AuthAction.RETURN_NULL,
    whenUnauthedAfterInit: AuthAction.RENDER,
})(Auth)
